import React from 'react';
import { Typography } from '@mui/material';
import ClaimFormInfoDialog from './ClaimFormInfoDialog';

type Props = {
  open: boolean;
  onOk: () => void;
};

const InventoryEmptyOverlayDialog: React.FC<Props> = ({ open, onOk }) => (
  <ClaimFormInfoDialog
    open={open}
    onOk={onOk}
    title="Damage inventory"
    titleId="inventory-empty-dialog-title"
  >
    <Typography variant="body2" component="p" sx={{ mb: 1.5 }}>
      This is the beginning of your list of damaged/stolen items.
    </Typography>
    <Typography variant="body2" component="p" sx={{ mb: 1.5 }}>
      Use this form to enter your 1st item.
    </Typography>
    <Typography variant="body2" component="p" sx={{ mb: 1.5, fontWeight: 700 }}>
      1 item at a time.
    </Typography>
    <Typography variant="body2" component="p">
      You will complete this step for each item claimed
    </Typography>
  </ClaimFormInfoDialog>
);

export default InventoryEmptyOverlayDialog;
